import { COLOR_PALETTE } from 'constants/ui';

export const selectionBarSx = {
  mx: '6px',
  mb: '6px',
  px: '10px',
  py: '8px',
  backgroundColor: COLOR_PALETTE.BRAND[7],
  color: 'common.white',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '12px',
  fontWeight: 500,
  flexShrink: 0,
};

export const actionButtonSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '5px',
  backgroundColor: 'rgba(255,255,255,0.16)',
  color: 'common.white',
  fontSize: '12px',
  fontWeight: 500,
  px: '9px',
  py: '5px',
  borderRadius: '6px',
  textTransform: 'none',
  minWidth: 0,
  lineHeight: 1,
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.28)',
  },
  '&.Mui-disabled': {
    color: 'rgba(255,255,255,0.4)',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
};

export const selectedCountSx = {
  flex: 1,
};

export const closeButtonSx = {
  marginLeft: 'auto',
  opacity: 0.8,
  color: 'common.white',
  minWidth: 0,
  padding: 0,
  lineHeight: 1,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '13px',
  '&:hover': {
    opacity: 1,
    backgroundColor: 'transparent',
  },
};

export const leadIconSx = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};
